import React, { useContext, useMemo, useState } from 'react'
import { useRj, useRunRj } from 'react-rocketjump'
import {
  useQsDataTable as useDataTable,
  useQsDataTable,
} from 'react-use-datatable/react'
import Select from 'react-select'
import { LavorazioniState } from '../localstate/lavorazioni'
import Paginator from '../../../components/Paginator'
import Spinner from 'reactstrap/lib/Spinner'
import { OperatoriState } from '../localstate/operatori'
import DateRangeQsFilter from '../../../components/Planner/DateRangeQsFilter'
import OrdersSelectAutoComplete from '../../../components/OrdersSelectAutoComplete'
import classNames from 'classnames'
import moment from 'moment'
import {
  AvanzamentiOrdiniState,
  AvanzamentoOrdinePerCommessaState,
  AvanzamentoPerGiornoState,
  DownloadAvanzamentiState,
  UpdatePercentualeOrdineFornitore,
} from '../localstate'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { Link } from 'react-router-dom'
import { orderBy, sumBy } from 'lodash'
import { Field, Formik } from 'formik'
import { DateField, InputField } from '../../../components/Form/Fields'
import { ConfigPlannerContext } from '../../../context'
import { transformErrorForForm } from '../../../components/Form/Fields/utils'
import ModalRimanenze from './ModalRimanenze'
import { ProgettiOrdineState } from '../../AdminPreventiviApp/localstate'
// import { AttivitaAdminState } from '../localstate/attivita'
import * as XLSX from 'xlsx'

const downloadTableToExcel = (
  avanzamentiCommesseWithMateriali,
  avanzamentiPerCommessaOrdered,
  intestazioneThMateriali
) => {
  // Prepare the data for Excel
  const excelData = []

  // Create header rows
  const headerRow1 = [
    'Ordine',
    'Progetto',
    'Tipo cliente',
    'Netto ordine',
    'Valore tot. materiali',
    'Valore econ. materiali',
    'Perc. Materiali',
    'Perc. Manodopera',
    'Valore tot. manodopera',
    'Valore econ. manodopera',
    ...intestazioneThMateriali.map((m) => `Valore ${m}`),
    'Totale valore economico',
    'Percentuale avanzamento',
  ]

  // Add summary row with totals
  const summaryRow = [
    'TOTALI',
    '',
    '',
    avanzamentiCommesseWithMateriali
      ? sumBy(avanzamentiCommesseWithMateriali, 'ordine_data.netto').toFixed(2)
      : '0',
    avanzamentiCommesseWithMateriali
      ? sumBy(
          avanzamentiCommesseWithMateriali,
          'totale_valore_materiali'
        ).toFixed(2)
      : '0',
    avanzamentiCommesseWithMateriali
      ? sumBy(
          avanzamentiCommesseWithMateriali,
          'valore_economico_materiale'
        ).toFixed(2)
      : '0',
    '',
    '',
    avanzamentiCommesseWithMateriali
      ? sumBy(
          avanzamentiCommesseWithMateriali,
          'totale_valore_manodopera'
        ).toFixed(2)
      : '0',
    avanzamentiCommesseWithMateriali
      ? sumBy(
          avanzamentiCommesseWithMateriali,
          (av) => av.totale_valore_economico - av.valore_economico_materiale
        ).toFixed(2)
      : '0',
    ...intestazioneThMateriali.map((m) =>
      avanzamentiCommesseWithMateriali
        ? sumBy(
            avanzamentiCommesseWithMateriali,
            (av) =>
              av.valori_materiali.find((valore) => valore.materiale === m)
                ?.valore_economico_materiale
          )?.toFixed(2) || '0'
        : '0'
    ),
    avanzamentiCommesseWithMateriali
      ? sumBy(
          avanzamentiCommesseWithMateriali,
          'totale_valore_economico'
        ).toFixed(2)
      : '0',
    '',
  ]

  excelData.push(summaryRow)
  excelData.push(headerRow1)

  // Add data rows
  if (avanzamentiPerCommessaOrdered) {
    avanzamentiPerCommessaOrdered.forEach((av) => {
      const row = [
        `${av.ordine_data?.numero_commessa} - ${av.ordine_data?.cliente?.nome}`,
        av.ordine_data?.progetto || '',
        av.ordine_data.agente_data?.tipo_agente || 'Non definito',
        av.ordine_data?.netto ? av.ordine_data.netto.toFixed(2) : '0',
        av.totale_valore_materiali?.toFixed(2) || '0',
        av.valore_economico_materiale?.toFixed(2) || '0',
        av.ordine_data?.netto
          ? ((av.totale_valore_materiali / av.ordine_data.netto) * 100).toFixed(
              2
            ) + '%'
          : '0%',
        av.ordine_data?.netto
          ? (
              (av.totale_valore_manodopera / av.ordine_data.netto) *
              100
            ).toFixed(2) + '%'
          : '0%',
        av.totale_valore_manodopera?.toFixed(2) || '0',
        (av.totale_valore_economico - av.valore_economico_materiale)?.toFixed(
          2
        ) || '0',
        ...intestazioneThMateriali.map((m) => {
          const valoreInRange = av.valori_materiali.find(
            (valore) => valore.materiale === m
          )?.valore_economico_materiale
          const valoreFuoriRange = av.valori_materiali_fuori_range.find(
            (valore) => valore.materiale === m
          )?.valore_economico_materiale

          let cellValue = valoreInRange ? valoreInRange.toFixed(2) : '0'
          if (valoreFuoriRange) {
            cellValue += ` (+${valoreFuoriRange.toFixed(2)})`
          }

          const percentuale = av.valori_materiali.find(
            (valore) => valore.materiale === m
          )?.totale_percentuale_materiali
          if (m !== 'rivendita' && percentuale) {
            cellValue += ` - ${percentuale.toFixed(2)}%`
          }

          return cellValue
        }),
        av.totale_valore_economico?.toFixed(2) || '0',
        av.percentuale_avanzamento?.toFixed(2) + '%' || '0%',
      ]
      excelData.push(row)
    })
  }

  // Create workbook and worksheet
  const wb = XLSX.utils.book_new()
  const ws = XLSX.utils.aoa_to_sheet(excelData)

  // Set column widths
  const colWidths = [
    { wch: 30 }, // Ordine
    { wch: 20 }, // Progetto
    { wch: 15 }, // Tipo cliente
    { wch: 15 }, // Netto ordine
    { wch: 18 }, // Valore tot. materiali
    { wch: 18 }, // Valore econ. materiali
    { wch: 15 }, // Perc. Materiali
    { wch: 15 }, // Perc. Manodopera
    { wch: 18 }, // Valore tot. manodopera
    { wch: 18 }, // Valore econ. manodopera
    ...intestazioneThMateriali.map(() => ({ wch: 20 })), // Material columns
    { wch: 20 }, // Totale valore economico
    { wch: 20 }, // Percentuale avanzamento
  ]
  ws['!cols'] = colWidths

  // Style the header and summary rows
  const range = XLSX.utils.decode_range(ws['!ref'])

  // Style summary row (first row)
  for (let col = range.s.c; col <= range.e.c; col++) {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col })
    if (!ws[cellAddress]) ws[cellAddress] = { t: 's', v: '' }
    ws[cellAddress].s = {
      font: { bold: true, color: { rgb: 'FFFFFF' } },
      fill: { fgColor: { rgb: '0066CC' } },
      alignment: { horizontal: 'center' },
    }
  }

  // Style header row (second row)
  for (let col = range.s.c; col <= range.e.c; col++) {
    const cellAddress = XLSX.utils.encode_cell({ r: 1, c: col })
    if (!ws[cellAddress]) ws[cellAddress] = { t: 's', v: '' }
    ws[cellAddress].s = {
      font: { bold: true },
      fill: { fgColor: { rgb: 'E6E6E6' } },
      alignment: { horizontal: 'center' },
    }
  }

  // Add worksheet to workbook
  XLSX.utils.book_append_sheet(wb, ws, 'Avanzamenti Commesse')

  // Generate filename with current date
  const currentDate = new Date().toISOString().split('T')[0]
  const filename = `avanzamenti_commesse_${currentDate}.xlsx`

  // Download the file
  XLSX.writeFile(wb, filename)
}

const downloadMaterialiTableToExcel = (
  avanzamentiCommesseWithMateriali,
  avanzamentiPerCommessaMaterialiOrdered,
  intestazioneThMateriali
) => {
  // Prepare the data for Excel
  const excelData = []

  // Create header rows with separate columns for values and percentages
  const headerRow1 = [
    'Ordine',
    'Progetto',
    'Tipo cliente',
    'Netto ordine',
    // For each material, create two columns: value and percentage
    ...intestazioneThMateriali.flatMap((m) => [`Valore ${m}`, `% ${m}`]),
    ...intestazioneThMateriali.flatMap((m) => [`Data arrivo ${m}`]),
    'Perc. totale',
    'Perc. materiali',
    'Perc. fuori range',
    'Totale valore economico',
    'Percentuale avanzamento',
  ]

  // Add summary row with totals - USE NUMBERS, NOT STRINGS
  const summaryRow = [
    'TOTALI',
    '',
    '',
    avanzamentiCommesseWithMateriali
      ? sumBy(avanzamentiCommesseWithMateriali, 'ordine_data.netto') // Remove .toFixed(2)
      : 0, // Use 0 instead of '0'

    // For each material in summary, add value and empty percentage column
    ...intestazioneThMateriali.flatMap((m) => [
      avanzamentiCommesseWithMateriali
        ? sumBy(avanzamentiCommesseWithMateriali, (av) =>
            sumBy(
              av.valori_materiali.filter((valore) => valore.materiale === m),
              'valore_economico_materiale_avanzamento'
            )
          ) || 0 // Remove .toFixed(2), use 0 instead of '0'
        : 0,
      null, // Use null for empty percentage column in summary
    ]),
    ...intestazioneThMateriali.flatMap(() => [null]), // Empty data arrivo columns in summary

    null, // Perc. totale - empty for summary
    null, // Perc. materiali - empty for summary
    null, // Perc. fuori range - empty for summary

    avanzamentiCommesseWithMateriali
      ? sumBy(
          avanzamentiCommesseWithMateriali,
          'totale_valore_materiali_avanzamento'
        ) // Remove .toFixed(2)
      : 0,

    avanzamentiCommesseWithMateriali
      ? sumBy(
          avanzamentiCommesseWithMateriali,
          'totale_valore_materiali_avanzamento'
        ) / sumBy(avanzamentiCommesseWithMateriali, 'ordine_data.netto')
      : // Remove * 100 and .toFixed(2) - store as decimal
        0,
  ]

  excelData.push(summaryRow)
  excelData.push(headerRow1)

  // Add data rows
  if (avanzamentiPerCommessaMaterialiOrdered) {
    avanzamentiPerCommessaMaterialiOrdered.forEach((av) => {
      // Calculate percentages as decimals (Excel will format as percentages)
      const totalMaterialiValue = sumBy(
        av.valori_materiali,
        'valore_economico_materiale_avanzamento'
      )
      const totalFuoriRangeValue = sumBy(
        av.valori_materiali_fuori_range,
        'valore_economico_materiale_avanzamento'
      )
      const nettoOrdine = av.ordine_data?.netto || 1 // Avoid division by zero

      const percTotale =
        (totalMaterialiValue + totalFuoriRangeValue) / nettoOrdine
      const percMateriali = totalMaterialiValue / nettoOrdine
      const percFuoriRange = totalFuoriRangeValue / nettoOrdine


      const row = [
        `${av.ordine_data?.numero_commessa} - ${av.ordine_data?.cliente?.nome}${
          av?.has_warnings_fornitori ? ' [WARNING]' : ''
        }`,
        av.ordine_data?.progetto || '',
        av.ordine_data.agente_data?.tipo_agente || 'Non definito',
        av.ordine_data?.netto || 0, // Use number, not string

        // For each material, add value and percentage in separate columns
        ...intestazioneThMateriali.flatMap((m) => {
          const valoreInRange =
            av.valori_materiali.find((valore) => valore.materiale === m)
              ?.valore_economico_materiale_avanzamento || 0

          const valoreFuoriRange =
            av.valori_materiali_fuori_range.find(
              (valore) => valore.materiale === m
            )?.valore_economico_materiale_avanzamento || 0

          let cellValue = 0
          let cellPercentage = 0

          if (valoreInRange > 0 && valoreFuoriRange > 0) {
            // Both values present - keep as text for clarity
            cellValue = `${valoreInRange.toFixed(
              2
            )} + FUORI RANGE: ${valoreFuoriRange.toFixed(2)}`
            cellPercentage = (valoreInRange + valoreFuoriRange) / nettoOrdine
          } else if (valoreInRange > 0) {
            // Only in-range value
            cellValue = valoreInRange
            cellPercentage = valoreInRange / nettoOrdine
          } else if (valoreFuoriRange > 0) {
            // Only out-of-range value - keep as text for clarity
            cellValue = `FUORI RANGE: ${valoreFuoriRange.toFixed(2)}`
            cellPercentage = valoreFuoriRange / nettoOrdine
          }

          return [cellValue, cellPercentage]
        }),
        // Data arrivo columns 
        ...intestazioneThMateriali.flatMap((m) => {
          // return max data_arrivo for that material
          const dataArrivoInRange = av.valori_materiali
            .filter((valore) => valore.materiale === m)
            .map((valore) => valore.ordini_fornitori.map((of) => of.data_arrivo))
            .flat()
          const dataArrivoFuoriRange = av.valori_materiali_fuori_range
            .filter((valore) => valore.materiale === m)
            .map((valore) => valore.ordini_fornitori.map((of) => of.data_arrivo))
            .flat()
            .filter((date) => date) // Remove null/undefined

          const allDates = [...dataArrivoInRange, ...dataArrivoFuoriRange]
          console.log('allDates', allDates)
          if (allDates.length === 0) return [null] // No dates available
          const maxDate = allDates.reduce((a, b) => (a > b ? a : b))
          return [maxDate ? moment(maxDate).format('YYYY-MM-DD') : null]
        }),

        percTotale,
        percMateriali,
        percFuoriRange,
        av.totale_valore_materiali_avanzamento || 0,
        (av.percentuale_avanzamento_av_materiali || 0) / 100, // Convert to decimal for percentage formatting
      ]
      excelData.push(row)
    })
  }

  // Create workbook and worksheet
  const wb = XLSX.utils.book_new()
  const ws = XLSX.utils.aoa_to_sheet(excelData)

  // Set column widths - updated for the new column structure
  const colWidths = [
    { wch: 35 }, // Ordine
    { wch: 20 }, // Progetto
    { wch: 15 }, // Tipo cliente
    { wch: 15 }, // Netto ordine
    // For each material: value column (wider) and percentage column (narrower)
    ...intestazioneThMateriali.flatMap(() => [
      { wch: 25 }, // Material value column
      { wch: 12 }, // Material percentage column
    ]),
    ...intestazioneThMateriali.map(() => ({ wch: 15 })), // Data arrivo columns
    { wch: 12 }, // Perc. totale
    { wch: 12 }, // Perc. materiali
    { wch: 12 }, // Perc. fuori range
    { wch: 20 }, // Totale valore economico
    { wch: 20 }, // Percentuale avanzamento
  ]
  ws['!cols'] = colWidths

  // Apply number formatting to cells
  const range = XLSX.utils.decode_range(ws['!ref'])

  for (let row = 0; row <= range.e.r; row++) {
    for (let col = 0; col <= range.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ r: row, c: col })
      if (!ws[cellAddress]) continue

      const cellValue = ws[cellAddress].v
      const isHeaderRow = row === 1
      const isSummaryRow = row === 0

      if (isHeaderRow || isSummaryRow) continue

      // Format currency/number columns (Netto ordine, material values, totals)
      if (
        col === 3 || // Netto ordine
        (col >= 4 &&
          col < 4 + intestazioneThMateriali.length * 2 &&
          (col - 4) % 2 === 0) || // Material value columns (even indices)
        col === headerRow1.length - 2
      ) {
        // Totale valore economico

        if (typeof cellValue === 'number') {
          ws[cellAddress].z = '#,##0.00' // Number format with 2 decimals and thousands separator
        }
      }

      // Format percentage columns
      if (
        (col >= 4 &&
          col < 4 + intestazioneThMateriali.length * 2 &&
          (col - 4) % 2 === 1) || // Material percentage columns (odd indices)
        col === headerRow1.length - 5 || // Perc. totale
        col === headerRow1.length - 4 || // Perc. materiali
        col === headerRow1.length - 3 || // Perc. fuori range
        col === headerRow1.length - 1
      ) {
        // Percentuale avanzamento

        if (typeof cellValue === 'number') {
          ws[cellAddress].z = '0.00%' // Percentage format
        }
      }
    }
  }

  // Style the header and summary rows
  // Style summary row (first row)
  for (let col = range.s.c; col <= range.e.c; col++) {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col })
    if (!ws[cellAddress]) ws[cellAddress] = { t: 's', v: '' }
    ws[cellAddress].s = {
      font: { bold: true, color: { rgb: 'FFFFFF' } },
      fill: { fgColor: { rgb: '0066CC' } },
      alignment: { horizontal: 'center' },
    }
  }

  // Style header row (second row)
  for (let col = range.s.c; col <= range.e.c; col++) {
    const cellAddress = XLSX.utils.encode_cell({ r: 1, c: col })
    if (!ws[cellAddress]) ws[cellAddress] = { t: 's', v: '' }
    ws[cellAddress].s = {
      font: { bold: true },
      fill: { fgColor: { rgb: 'E6E6E6' } },
      alignment: { horizontal: 'center' },
    }
  }

  // Add conditional formatting for percentage completion
  for (let row = 2; row < excelData.length; row++) {
    // Style percentage avanzamento column (last column)
    const lastColIndex = headerRow1.length - 1
    const cellAddress = XLSX.utils.encode_cell({ r: row, c: lastColIndex })
    if (ws[cellAddress] && ws[cellAddress].v) {
      const percentageValue = ws[cellAddress].v
      // Check if it's 100% (1.0 in decimal format)
      if (typeof percentageValue === 'number' && percentageValue >= 1.0) {
        ws[cellAddress].s = {
          font: { color: { rgb: '008000' }, bold: true }, // Green for 100%
          fill: { fgColor: { rgb: 'E6FFE6' } },
        }
      }
    }
  }

  // Add worksheet to workbook
  XLSX.utils.book_append_sheet(wb, ws, 'Avanzamenti Materiali')

  // Generate filename with current date
  const currentDate = new Date().toISOString().split('T')[0]
  const filename = `avanzamenti_materiali_${currentDate}.xlsx`

  // Download the file
  XLSX.writeFile(wb, filename)
}

const AVANZAMENTI_TIPO_EVENTO = {
  attivita_operatore: 'Attività operatore',
  arrivo_materiale: 'Arrivo materiale',
}

const BIG_PAGE_PARAMS = { page_size: 1000 }

export default function AvanzamentoOrdini() {
  const [{ lavorazioni }] = useRunRj(LavorazioniState, [BIG_PAGE_PARAMS])
  const [{ operatori }] = useRunRj(OperatoriState, [BIG_PAGE_PARAMS])
  const [{ data: progetti }] = useRunRj(ProgettiOrdineState, [BIG_PAGE_PARAMS])

  const [
    // Data State
    { avanzamenti, pagination, loading, totals },
    // Table state
    { page, ...filters },
    {
      // DT Actions
      onFiltersChange,
      onFilterChange,
      goToPage,
      run: runAvanzamenti,
    },
  ] = useQsDataTable(AvanzamentiOrdiniState, () => ({
    operatore: '',
    lavorazione: '',
    ordine: '',
    from_date:
      localStorage.getItem('planner_from_date') ??
      moment().startOf('week').format('YYYY-MM-DD'),
    to_date:
      localStorage.getItem('planner_to_date') ??
      moment().endOf('week').format('YYYY-MM-DD'),
    lavorazioni: [],
    operatori: [],
    tipo_evento: '',
    materiale: '',
    tipo_agente: '',
    progetti: [],
    from_data_consegna: '',
    to_data_consegna: '',
  }))

  const [{ data }, { run: runDownloadAvanzamenti }] = useRj(
    DownloadAvanzamentiState
  )

  const filtersToUse = useMemo(() => {
    return {
      ...filters,
      page_size: 1000,
    }
  }, [filters])

  const [
    { list: avanzamentiCommesse, loading: loadingCommesse },
    {},
    { run: runAvanzamentiCommesse },
  ] = useQsDataTable(AvanzamentoOrdinePerCommessaState, () => ({
    ...filtersToUse,
  }))

  const [filtersMateriali, setFiltersMateriali] = useState(null)
  const [filtersMaterialiGlobal100, setFiltersMaterialiGlobal100] =
    useState(null)

  const avanzamentiCommesseWithMateriali = useMemo(() => {
    if (!avanzamentiCommesse) {
      return []
    }

    if (filtersMateriali === 'legno_non_conforme') {
      return avanzamentiCommesse.filter((av) =>
        av.valori_materiali.some(
          (valore) =>
            valore.materiale === 'legno' &&
            valore.totale_percentuale_materiali !== 100
        )
      )
    } else if (filtersMateriali === 'vetro_non_conforme') {
      return avanzamentiCommesse.filter((av) =>
        av.valori_materiali.some(
          (valore) =>
            valore.materiale === 'vetro' &&
            valore.totale_percentuale_materiali !== 100
        )
      )
    } else if (filtersMateriali === 'verniciatura_non_conforme') {
      return avanzamentiCommesse.filter((av) =>
        av.valori_materiali.some(
          (valore) =>
            valore.materiale === 'verniciatura' &&
            valore.totale_percentuale_materiali !== 100
        )
      )
    } else if (filtersMateriali === 'telai_non_conforme') {
      return avanzamentiCommesse.filter((av) =>
        av.valori_materiali.some(
          (valore) =>
            valore.materiale === 'telai' &&
            valore.totale_percentuale_materiali !== 100
        )
      )
    } else if (filtersMaterialiGlobal100 === 'materiali_al_100') {
      // we need to consider also valori_materiali_fuori_range
      return avanzamentiCommesse.filter((av) => {
        const totalValoreMateriali =
          sumBy(av.valori_materiali, 'valore_economico_materiale_avanzamento') +
          sumBy(
            av.valori_materiali_fuori_range,
            'valore_economico_materiale_avanzamento'
          )
        const percentuale = (totalValoreMateriali / av.ordine_data.netto) * 100
        return percentuale.toFixed(2) == '100.00'
      })
    } else if (filtersMaterialiGlobal100 === 'materiali_non_al_100') {
      return avanzamentiCommesse.filter((av) => {
        const totalValoreMateriali =
          sumBy(av.valori_materiali, 'valore_economico_materiale_avanzamento') +
          sumBy(
            av.valori_materiali_fuori_range,
            'valore_economico_materiale_avanzamento'
          )
        const percentuale = (totalValoreMateriali / av.ordine_data.netto) * 100

        return percentuale.toFixed(2) != '100.00'
      })
    } else {
      // foreach materiale set a field valore_materiale to the sum of all valori_materiali for that materiale
      avanzamentiCommesse.forEach((av) => {
        av.valori_materiali.forEach((valore) => {
          if (!valore.materiale) return
          const materiale = valore.materiale
          if (!av[`${materiale}_valore_materiale`]) {
            av[`${materiale}_valore_materiale`] = 0
          }
          av[`${materiale}_valore_materiale`] +=
            valore.valore_economico_materiale
        })
      })
      return avanzamentiCommesse
    }
  }, [avanzamentiCommesse, filtersMateriali, filtersMaterialiGlobal100])

  const [{ list: avanzamentoPerGiorno }] = useQsDataTable(
    AvanzamentoPerGiornoState,
    () => ({
      ...filtersToUse,
    })
  )

  const lavorazioniForSelect = useMemo(() => {
    if (!lavorazioni) {
      return []
    }
    return lavorazioni.map((lavorazione) => ({
      value: lavorazione.id,
      label: lavorazione.nome,
    }))
  }, [lavorazioni])

  const operatoriForSelect = useMemo(() => {
    if (!operatori) {
      return []
    }
    return operatori.map((operatore) => ({
      value: operatore.id,
      label: operatore.user.first_name + ' ' + operatore.user.last_name,
    }))
  }, [operatori])

  const selectedOperatori = useMemo(() => {
    if (!filters.operatori || !operatori) {
      return []
    }
    if (typeof filters.operatori === 'string') {
      return filters.operatori.split(',').map((id) => ({
        value: id,
        label:
          operatori.find((operatore) => operatore.id === Number(id)).user
            .first_name +
          ' ' +
          operatori.find((operatore) => operatore.id === Number(id)).user
            .last_name,
      }))
    } else {
      return filters.operatori.map((id) => ({
        value: id,
        label:
          operatori.find((operatore) => operatore.id === Number(id)).user
            .first_name +
          ' ' +
          operatori.find((operatore) => operatore.id === Number(id)).user
            .last_name,
      }))
    }
  }, [filters.operatori, operatori])

  const selectedLavorazioni = useMemo(() => {
    if (!filters.lavorazioni || !lavorazioni) {
      return []
    }
    if (typeof filters.lavorazioni === 'string') {
      return filters.lavorazioni.split(',').map((id) => ({
        value: id,
        label: lavorazioni.find((lavorazione) => lavorazione.id === Number(id))
          .nome,
      }))
    } else {
      return filters.lavorazioni.map((id) => ({
        value: id,
        label: lavorazioni.find((lavorazione) => lavorazione.id === Number(id))
          .nome,
      }))
    }
  }, [filters.lavorazioni, lavorazioni])

  const selectedProgetti = useMemo(() => {
    if (!filters.progetti || !progetti) {
      return []
    }
    if (typeof filters.progetti === 'string') {
      return filters.progetti.split(',').map((id) => ({
        value: progetti.find((progetto) => progetto === id),
        label: progetti.find((progetto) => progetto === id),
      }))
    } else {
      return filters.progetti.map((id) => ({
        value: progetti.find((progetto) => progetto === id),
        label: progetti.find((progetto) => progetto === id),
      }))
    }
  }, [filters.progetti, progetti])

  const [typeView, setTypeView] = useState('materiali') // materiali, commesse

  const intestazioneThMateriali = useMemo(() => {
    if (!avanzamentiCommesseWithMateriali) {
      return []
    }
    const materiali = []
    avanzamentiCommesseWithMateriali.forEach((av) => {
      av.valori_materiali.forEach((valore) => {
        if (!valore.materiale) return
        if (!materiali.includes(valore.materiale)) {
          materiali.push(valore.materiale)
        }
      })
      // check if there are legno, vetro, verniciatura, telai and add them if not present
      if (!materiali.includes('legno')) {
        materiali.push('legno')
      }
      if (!materiali.includes('vetro')) {
        materiali.push('vetro')
      }
      if (!materiali.includes('verniciatura')) {
        materiali.push('verniciatura')
      }
      if (!materiali.includes('telai')) {
        materiali.push('telai')
      }
      if (!materiali.includes('alluminio')) {
        materiali.push('alluminio')
      }
    })
    return materiali
  }, [avanzamentiCommesseWithMateriali])

  const [openModal, setOpenModal] = useState(null)
  const [modalRimanenze, setModalRimanenze] = useState(null)

  const { run: updatePercentuale } = useRj(UpdatePercentualeOrdineFornitore)[1]

  const { valoriStato } = useContext(ConfigPlannerContext)
  const stati = valoriStato.ordine_fornitore || []

  const [ordering, setOrdering] = useState({
    field: 'percentuale_avanzamento',
    direction: 'desc',
  })

  const [orderingMateriali, setOrderingMateriali] = useState({
    field: 'percentuale_avanzamento_av_materiali',
    direction: 'desc',
  })

  const avanzamentiPerCommessaMaterialiOrdered = useMemo(() => {
    if (!avanzamentiCommesseWithMateriali) {
      return []
    }
    const ordered = orderBy(
      avanzamentiCommesseWithMateriali,
      [orderingMateriali.field],
      [orderingMateriali.direction]
    )
    return ordered
  }, [avanzamentiCommesseWithMateriali, orderingMateriali])

  const avanzamentiPerCommessaOrdered = useMemo(() => {
    if (!avanzamentiCommesseWithMateriali) {
      return []
    }
    const ordered = orderBy(
      avanzamentiCommesseWithMateriali,
      [ordering.field],
      [ordering.direction]
    )
    return ordered
  }, [avanzamentiCommesseWithMateriali, ordering])

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <div className="filters mt-2">
            <div className="row">
              <div className="col-md-3">
                <Select
                  name="operatori"
                  isMulti
                  placeholder={'Filtra per operatori'}
                  options={operatoriForSelect.filter(
                    (operatore) =>
                      !selectedOperatori.find(
                        (item) => Number(item.value) === Number(operatore.value)
                      )
                  )}
                  classNamePrefix="multi-select"
                  hideSelectedOptions={false}
                  isOptionSelected={(option) =>
                    selectedOperatori.find(
                      (item) => item.value === option.value
                    )
                  }
                  value={selectedOperatori}
                  className="basic-multi-select select-multi-options text-nowrap w-100"
                  onChange={(newValues) => {
                    if (newValues) {
                      const items = newValues.map((item) => item.value)
                      onFilterChange(items, 'operatori')
                    } else {
                      onFilterChange([], 'operatori')
                    }
                  }}
                />
              </div>
              <div className="col-md-3">
                <Select
                  name="lavorazioni"
                  isMulti
                  placeholder={'Filtra per lavorazioni'}
                  options={lavorazioniForSelect.filter(
                    (lavorazione) =>
                      !selectedLavorazioni.find(
                        (item) =>
                          Number(item.value) === Number(lavorazione.value)
                      )
                  )}
                  classNamePrefix="multi-select"
                  hideSelectedOptions={false}
                  isOptionSelected={(option) =>
                    selectedLavorazioni.find(
                      (item) => item.value === option.value
                    )
                  }
                  value={selectedLavorazioni}
                  className="basic-multi-select select-multi-options text-nowrap w-100"
                  onChange={(newValues) => {
                    if (newValues) {
                      const items = newValues.map((item) => item.value)
                      onFilterChange(items, 'lavorazioni')
                    } else {
                      onFilterChange([], 'lavorazioni')
                    }
                  }}
                />
              </div>
              <div className="col-md-3">
                <OrdersSelectAutoComplete
                  value={filters.ordine}
                  hasValue
                  debounceTimeout={150}
                  loadOptionsOnMenuOpen
                  onChange={(ordine) => {
                    if (ordine) {
                      onFiltersChange({ ordine: ordine.id })
                    } else {
                      onFiltersChange({ ordine: '' })
                    }
                  }}
                  noOptionsMessage={() => 'Nessun ordine trovato'}
                  loadingMessage={() => 'Caricamento ordini...'}
                  placeholder={'Filtra per ordine'}
                  isClearable={true}
                  name={'ordine'}
                  additional={{
                    page: 1,
                  }}
                />
              </div>
              <div className="col-md-3">
                <select
                  className="form-control"
                  value={filters.tipo_evento}
                  onChange={(e) => {
                    onFilterChange(e.target.value, 'tipo_evento')
                  }}
                >
                  <option value="">Filtra per tipo evento</option>
                  {Object.keys(AVANZAMENTI_TIPO_EVENTO).map((key) => (
                    <option key={key} value={key}>
                      {AVANZAMENTI_TIPO_EVENTO[key]}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-3 mt-1">
                <DateRangeQsFilter
                  filters={filters}
                  onFiltersChange={(newFilters) => {
                    onFiltersChange(newFilters)
                    localStorage.setItem(
                      'planner_from_date',
                      newFilters.from_date
                    )
                    localStorage.setItem('planner_to_date', newFilters.to_date)
                  }}
                  startField="from_date"
                  endField="to_date"
                  withPortal={true}
                  customArrowIcon={<div />}
                  small={false}
                  noBorder
                />
              </div>
              <div className="col-md-3 mt-1">
                <select
                  className="form-control"
                  value={filters.materiale}
                  onChange={(e) => {
                    onFilterChange(e.target.value, 'materiale')
                  }}
                >
                  <option value="">Filtra per materiale</option>
                  <option value="vetro">Vetro</option>
                  <option value="legno">Legno</option>
                  <option value="verniciatura">Verniciatura</option>
                  <option value="telai">Telai</option>
                </select>
              </div>
              <div className="col-md-2 mt-1">
                <select
                  className="form-control"
                  value={filters.tipo_agente}
                  onChange={(e) =>
                    onFiltersChange({ tipo_agente: e.target.value })
                  }
                >
                  <option value={''}>Filtra per tipo cliente</option>
                  <option value={'B2C'}>B2C</option>
                  <option value={'B2B'}>B2B</option>
                  <option value={'B2C*s'}>B2C*s</option>
                </select>
              </div>
              <div className="col-md-2 mt-1">
                <select
                  className="form-control"
                  value={filtersMateriali}
                  onChange={(e) => {
                    setFiltersMateriali(e.target.value)
                  }}
                >
                  <option value="">Filtra per materiali non al 100%</option>
                  <option value="legno_non_conforme">Legno non 100%</option>
                  <option value="vetro_non_conforme">Vetro non 100%</option>
                  <option value="verniciatura_non_conforme">
                    Verniciatura non 100%
                  </option>
                  <option value="telai_non_conforme">Telai non 100%</option>
                </select>
              </div>
              <div className="col-md-2 mt-1">
                <select
                  className="form-control"
                  value={filtersMaterialiGlobal100}
                  onChange={(e) => {
                    setFiltersMaterialiGlobal100(e.target.value)
                  }}
                >
                  <option value="">
                    Filtra materiali al 100% / non al 100%
                  </option>
                  <option value="materiali_al_100">Materiali al 100%</option>
                  <option value="materiali_non_al_100">
                    Materiali non al 100%
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div className="row mt-1 mb-2">
            <div className="col-md-8 mt-3">
              <div>
                <div
                  className={classNames('btn pointer', {
                    'btn-primary': typeView === 'materiali',
                    'btn-outline-primary': typeView !== 'materiali',
                  })}
                  onClick={() => {
                    setTypeView('materiali')
                  }}
                >
                  Materiali
                </div>
                <div
                  className={classNames('btn pointer', {
                    'btn-primary': typeView === 'avanzamento-per-commessa',
                    'btn-outline-primary':
                      typeView !== 'avanzamento-per-commessa',
                  })}
                  onClick={() => {
                    setTypeView('avanzamento-per-commessa')
                  }}
                >
                  Per commessa
                </div>
                <div
                  className={classNames('btn pointer', {
                    'btn-primary': typeView === 'avanzamento-ordini',
                    'btn-outline-primary': typeView !== 'avanzamento-ordini',
                  })}
                  onClick={() => {
                    setTypeView('avanzamento-ordini')
                  }}
                >
                  Avanzamento
                </div>

                <div
                  className={classNames('btn pointer', {
                    'btn-primary': typeView === 'per-giorno',
                    'btn-outline-primary': typeView !== 'per-giorno',
                  })}
                  onClick={() => {
                    setTypeView('per-giorno')
                  }}
                >
                  Per giorno
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3 text-right">
              {(typeView === 'avanzamento-per-commessa' ||
                typeView === 'materiali') && (
                <Button
                  color="success"
                  onClick={() => {
                    {
                      typeView === 'avanzamento-per-commessa' &&
                        downloadTableToExcel(
                          avanzamentiCommesseWithMateriali,
                          avanzamentiPerCommessaOrdered,
                          intestazioneThMateriali
                        )
                      typeView === 'materiali' &&
                        downloadMaterialiTableToExcel(
                          avanzamentiCommesseWithMateriali,
                          avanzamentiPerCommessaMaterialiOrdered,
                          intestazioneThMateriali
                        )
                    }
                  }}
                >
                  <i className="fas fa-file-excel mr-2"></i>
                  Download Excel
                </Button>
              )}
            </div>
          </div>
          {(loading || loadingCommesse) && (
            <div className="text-center mt-4">
              <Spinner color="primary" />
            </div>
          )}
          <div
            className="mb-2"
            style={{
              height: 'calc(100vh - 280px)',
              overflowY: 'auto',
              overflowX: 'auto',
              width: 'calc(100vw - 30px)',
            }}
          >
            {avanzamenti && !loading && !loadingCommesse && (
              <div className="row">
                <div className="col-md-12">
                  {typeView === 'avanzamento-ordini' && (
                    <>
                      <table
                        cellSpacing={0}
                        className="table table-striped table-orders"
                      >
                        <thead
                          className="position-sticky"
                          style={{ top: 0, background: 'white', zIndex: 0 }}
                        >
                          <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>
                              <div className="badge badge-primary badge-xl">
                                {moment
                                  .duration(
                                    totals.tempo_teorico_totale,
                                    'seconds'
                                  )
                                  .days()}
                                g{' '}
                                {moment
                                  .duration(
                                    totals.tempo_teorico_totale,
                                    'seconds'
                                  )
                                  .hours()}
                                h{' '}
                                {moment
                                  .duration(
                                    totals.tempo_teorico_totale,
                                    'seconds'
                                  )
                                  .minutes()}
                                m
                              </div>
                            </th>
                            <th>
                              <div className="badge badge-primary badge-xl">
                                {moment
                                  .duration(
                                    totals.tempo_lavorazione_totale,
                                    'seconds'
                                  )
                                  .days()}
                                g{' '}
                                {moment
                                  .duration(
                                    totals.tempo_lavorazione_totale,
                                    'seconds'
                                  )
                                  .hours()}
                                h{' '}
                                {moment
                                  .duration(
                                    totals.tempo_lavorazione_totale,
                                    'seconds'
                                  )
                                  .minutes()}
                                m{/* show numero gg numero hh numero mm */}
                              </div>
                            </th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>
                              <div className="badge badge-primary badge-xl">
                                {totals.costo_materiale_totale?.toFixed(2)}
                              </div>
                            </th>
                            <th className="text-right">
                              <div className="badge badge-primary badge-xl">
                                {totals.valore_economico_totale?.toFixed(2)}
                              </div>
                            </th>
                          </tr>
                          <tr>
                            <th>Data</th>
                            <th>Ordine</th>
                            <th>Tipo cliente</th>
                            <th>Tipo Evento</th>
                            <th>Lavorazione</th>
                            <th>Operatore</th>
                            <th>Tempo teo.</th>
                            <th>Tempo lav.</th>
                            <th>Numero</th>
                            <th>Materiale</th>
                            <th>Ord. Forn.</th>
                            <th>N° Doc</th>
                            <th>Costo materiale</th>
                            <th>Valore economico</th>
                          </tr>
                        </thead>
                        <tbody>
                          {avanzamenti &&
                            avanzamenti?.map((av, i) => (
                              <tr
                                key={i}
                                className={
                                  av.tipo_evento === 'arrivo_materiale'
                                    ? 'table-info'
                                    : ''
                                }
                              >
                                <td>{moment(av.data).format('DD/MM/YYYY')}</td>
                                <td>
                                  {av.ordine_data?.numero_commessa} -{' '}
                                  {av.ordine_data?.cliente?.nome}
                                </td>
                                <td>
                                  {av.ordine_data.agente_data?.tipo_agente ? (
                                    av.ordine_data.agente_data?.tipo_agente
                                  ) : (
                                    <span className="text-danger">
                                      Non definito
                                    </span>
                                  )}
                                </td>
                                <td>
                                  {AVANZAMENTI_TIPO_EVENTO[av.tipo_evento] ??
                                    av.tipo_evento}
                                </td>
                                <td>{av.lavorazione_data?.nome}</td>
                                <td>
                                  {av.operatore_data?.user?.first_name}{' '}
                                  {av.operatore_data?.user?.last_name}
                                </td>
                                <td>
                                  {AVANZAMENTI_TIPO_EVENTO[av.tipo_evento] ===
                                    'Attività operatore' &&
                                    parseInt(
                                      moment
                                        .duration(av.tempo_teorico)
                                        .as('minutes')
                                    ) + ' min'}
                                </td>
                                <td>
                                  {AVANZAMENTI_TIPO_EVENTO[av.tipo_evento] ===
                                    'Attività operatore' &&
                                    parseInt(
                                      moment
                                        .duration(av.tempo_lavorazione)
                                        .as('minutes')
                                    ) + ' min'}
                                </td>
                                <td>
                                  {AVANZAMENTI_TIPO_EVENTO[av.tipo_evento] ===
                                    'Attività operatore' && (
                                    <>
                                      {av.numero_pezzi} /{' '}
                                      {av.numero_pezzi_totali}{' '}
                                      {av.lavorazione_data?.attivita_numero ===
                                      'numero'
                                        ? // ? check if is 1 or bigger than 1
                                          ' Telai'
                                        : av.lavorazione_data
                                            ?.attivita_numero === 'n_vetri'
                                        ? ' Vetri'
                                        : ' Ante'}
                                    </>
                                  )}
                                </td>
                                <td className="text-capitalize">
                                  {av.materiale_data?.nome}
                                </td>
                                <td>
                                  {
                                    av.ordine_fornitore_data?.fornitore_data
                                      ?.nome
                                  }
                                </td>
                                <td>{av.numero_documento}</td>
                                <td>{av.costo_materiale?.toFixed(2)}</td>
                                <td className="text-right">
                                  {av.valore_economico?.toFixed(2)}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </>
                  )}
                  {typeView === 'avanzamento-per-commessa' && (
                    <table className="table table-striped table-orders">
                      <thead
                        className="position-sticky"
                        style={{ top: 0, background: 'white', zIndex: 0 }}
                      >
                        <tr>
                          <th></th>
                          <th className="text-nowrap">
                            <div style={{ width: 200 }}>
                              <Select
                                name="progetti"
                                isClearable={true}
                                placeholder={'Filtra per progetto'}
                                options={progetti?.map((progetto) => ({
                                  value: progetto,
                                  label: progetto,
                                }))}
                                classNamePrefix="multi-select"
                                hideSelectedOptions={false}
                                isMulti={true}
                                value={selectedProgetti}
                                className="basic-multi-select select-multi-options text-nowrap w-100"
                                onChange={(newValues) => {
                                  if (newValues) {
                                    const items = newValues.map(
                                      (item) => item.value
                                    )
                                    onFilterChange(items, 'progetti')
                                  } else {
                                    onFilterChange([], 'progetti')
                                  }
                                }}
                              />
                            </div>
                          </th>
                          <th></th>
                          <th>
                            <div className="badge badge-primary badge-xl">
                              {avanzamentiCommesseWithMateriali &&
                                sumBy(
                                  avanzamentiCommesseWithMateriali,
                                  'ordine_data.netto'
                                ).toFixed(2)}
                            </div>
                          </th>
                          <th>
                            <div className="badge badge-primary badge-xl">
                              {avanzamentiCommesseWithMateriali &&
                                sumBy(
                                  avanzamentiCommesseWithMateriali,
                                  'totale_valore_materiali'
                                ).toFixed(2)}
                            </div>
                          </th>
                          <th>
                            <div className="badge badge-primary badge-xl">
                              {avanzamentiCommesseWithMateriali &&
                                sumBy(
                                  avanzamentiCommesseWithMateriali,
                                  'valore_economico_materiale'
                                ).toFixed(2)}
                            </div>
                          </th>
                          <th></th>
                          <th></th>
                          <th>
                            <div className="badge badge-primary badge-xl">
                              {avanzamentiCommesseWithMateriali &&
                                sumBy(
                                  avanzamentiCommesseWithMateriali,
                                  'totale_valore_manodopera'
                                )?.toFixed(2)}
                            </div>
                          </th>

                          <th>
                            <div className="badge badge-primary badge-xl">
                              {avanzamentiCommesseWithMateriali &&
                                sumBy(
                                  avanzamentiCommesseWithMateriali,
                                  (av) =>
                                    av.totale_valore_economico -
                                    av.valore_economico_materiale
                                )?.toFixed(2)}
                            </div>
                          </th>
                          {intestazioneThMateriali.map((m, i) => (
                            <th key={i}>
                              <div className="badge badge-primary badge-xl">
                                {avanzamentiCommesseWithMateriali &&
                                  sumBy(
                                    avanzamentiCommesseWithMateriali,
                                    (av) =>
                                      av.valori_materiali.find(
                                        (valore) => valore.materiale === m
                                      )?.valore_economico_materiale
                                  )?.toFixed(2)}
                              </div>
                            </th>
                          ))}

                          <th>
                            <div className="badge badge-primary badge-xl">
                              {avanzamentiCommesseWithMateriali &&
                                sumBy(
                                  avanzamentiCommesseWithMateriali,
                                  'totale_valore_economico'
                                ).toFixed(2)}
                            </div>
                          </th>
                          <th></th>
                        </tr>
                        <tr>
                          <th>Ordine</th>
                          <th>Progetto</th>
                          <th>Tipo cliente</th>
                          <th
                            className="position-relative pointer"
                            onClick={() => {
                              setOrdering({
                                field: 'ordine_data.netto',
                                direction:
                                  ordering.field === 'ordine_data.netto' &&
                                  ordering.direction === 'asc'
                                    ? 'desc'
                                    : 'asc',
                              })
                            }}
                          >
                            <span className="mr-3">Netto ordine</span>
                            <i
                              style={{
                                position: 'absolute',
                                top: 'calc(50% - 9px)',
                                right: 0,
                                color:
                                  ordering.field === 'ordine_data.netto' &&
                                  ordering.direction === 'asc'
                                    ? 'black'
                                    : '#ccc',
                              }}
                              className="fas fa-sort-up"
                            />
                            <i
                              style={{
                                position: 'absolute',
                                top: 'calc(50% - 7px)',
                                right: 0,
                                color:
                                  ordering.field === 'ordine_data.netto' &&
                                  ordering.direction === 'desc'
                                    ? 'black'
                                    : '#ccc',
                              }}
                              className="fas fa-sort-down"
                            />
                          </th>
                          <th>Valore tot. materiali</th>
                          <th>Valore econ. materiali</th>
                          <th>Perc. Materiali</th>
                          <th>Perc. Manodopera</th>
                          <th>Valore tot. manodopera</th>
                          <th>Valore econ. manodopera</th>
                          {intestazioneThMateriali.map((m, i) => (
                            <th
                              key={i}
                              className="text-capitalize pointer position-relative"
                              onClick={() => {
                                setOrdering({
                                  field: `${m}_valore_materiale`,
                                  direction:
                                    ordering.field ===
                                      `${m}_valore_materiale` &&
                                    ordering.direction === 'asc'
                                      ? 'desc'
                                      : 'asc',
                                })
                              }}
                            >
                              <span className="mr-3">Valore {m}</span>
                              <i
                                style={{
                                  position: 'absolute',
                                  top: 'calc(50% - 9px)',
                                  right: 0,
                                  color:
                                    ordering.field ===
                                      `${m}_valore_materiale` &&
                                    ordering.direction === 'asc'
                                      ? 'black'
                                      : '#ccc',
                                }}
                                className="fas fa-sort-up"
                              />
                              <i
                                style={{
                                  position: 'absolute',
                                  top: 'calc(50% - 7px)',
                                  right: 0,
                                  color:
                                    ordering.field ===
                                      `${m}_valore_materiale` &&
                                    ordering.direction === 'desc'
                                      ? 'black'
                                      : '#ccc',
                                }}
                                className="fas fa-sort-down"
                              />
                            </th>
                          ))}
                          <th>Totale valore economico</th>
                          <th
                            className="position-relative pointer"
                            onClick={() => {
                              setOrdering({
                                field: 'percentuale_avanzamento',
                                direction:
                                  ordering.field ===
                                    'percentuale_avanzamento' &&
                                  ordering.direction === 'asc'
                                    ? 'desc'
                                    : 'asc',
                              })
                            }}
                          >
                            {' '}
                            <span>Percentuale avanzamento</span>
                            <i
                              style={{
                                position: 'absolute',
                                top: 'calc(50% - 9px)',
                                right: 0,
                                color:
                                  ordering.field ===
                                    'percentuale_avanzamento' &&
                                  ordering.direction === 'asc'
                                    ? 'black'
                                    : '#ccc',
                              }}
                              className="fas fa-sort-up"
                            />
                            <i
                              style={{
                                position: 'absolute',
                                top: 'calc(50% - 7px)',
                                right: 0,
                                color:
                                  ordering.field ===
                                    'percentuale_avanzamento' &&
                                  ordering.direction === 'desc'
                                    ? 'black'
                                    : '#ccc',
                              }}
                              className="fas fa-sort-down"
                            />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {avanzamentiPerCommessaOrdered &&
                          avanzamentiPerCommessaOrdered?.map((av, i) => (
                            <tr key={i}>
                              <td>
                                <Link to={`/ordini/${av.ordine_data.id}/`}>
                                  {av.ordine_data?.numero_commessa} -{' '}
                                  {av.ordine_data?.cliente?.nome}
                                </Link>
                                {av?.has_warnings_fornitori ? (
                                  <Link
                                    to={`/ordini/${av.ordine_data?.id}/avanzamento`}
                                  >
                                    <i
                                      className="fas fa-exclamation-triangle text-warning ml-2"
                                      title="Attenzione ordini fornitori non completi"
                                    ></i>
                                  </Link>
                                ) : null}
                              </td>
                              <td>{av.ordine_data?.progetto}</td>
                              <td>
                                {av.ordine_data.agente_data?.tipo_agente ? (
                                  av.ordine_data.agente_data?.tipo_agente
                                ) : (
                                  <span className="text-danger">
                                    Non definito
                                  </span>
                                )}
                              </td>

                              <td>
                                {av.ordine_data?.netto
                                  ? av.ordine_data?.netto?.toFixed(2)
                                  : 0}
                              </td>
                              <td>{av.totale_valore_materiali?.toFixed(2)}</td>
                              <td>
                                {av.valore_economico_materiale?.toFixed(2)}
                              </td>
                              <td>
                                {av.ordine_data?.netto
                                  ? (
                                      (av.totale_valore_materiali /
                                        av.ordine_data?.netto) *
                                      100
                                    )?.toFixed(2)
                                  : 0}
                                %
                              </td>
                              <td>
                                {av.ordine_data?.netto
                                  ? (
                                      (av.totale_valore_manodopera /
                                        av.ordine_data?.netto) *
                                      100
                                    )?.toFixed(2)
                                  : 0}
                                %
                              </td>
                              <td>{av.totale_valore_manodopera?.toFixed(2)}</td>

                              <td>
                                {(
                                  av.totale_valore_economico -
                                  av.valore_economico_materiale
                                )?.toFixed(2)}

                                <Button
                                  type="button"
                                  size="sm"
                                  outline
                                  color="primary"
                                  className="mt-1"
                                  onClick={() => {
                                    setModalRimanenze({
                                      id: av.ordine_data.id,
                                      ordine_data: av.ordine_data,
                                    })
                                  }}
                                >
                                  <i className="fas fa-pencil-alt mr-1"></i>
                                  Attività
                                </Button>
                              </td>
                              {intestazioneThMateriali.map((m, i) => (
                                <td key={i}>
                                  {av.valori_materiali.find(
                                    (valore) => valore.materiale === m
                                  )?.valore_economico_materiale ? (
                                    av.valori_materiali
                                      .find((valore) => valore.materiale === m)
                                      ?.valore_economico_materiale.toFixed(2)
                                  ) : (
                                    <span className="text-danger">
                                      {av.valori_materiali_fuori_range
                                        .find(
                                          (valore) => valore.materiale === m
                                        )
                                        ?.valore_economico_materiale?.toFixed(
                                          2
                                        )}
                                    </span>
                                  )}
                                  <br />
                                  {av.valori_materiali_fuori_range.find(
                                    (valore) => valore.materiale === m
                                  )?.valore_economico_materiale && (
                                    <small className="text-danger">
                                      (+
                                      {av.valori_materiali_fuori_range
                                        .find(
                                          (valore) => valore.materiale === m
                                        )
                                        ?.valore_economico_materiale?.toFixed(
                                          2
                                        )}
                                      )
                                    </small>
                                  )}
                                  <br />
                                  <small
                                    className={classNames({
                                      'text-danger':
                                        av.valori_materiali.find(
                                          (valore) => valore.materiale === m
                                        )?.totale_percentuale_materiali !== 100,
                                      'text-success':
                                        av.valori_materiali.find(
                                          (valore) => valore.materiale === m
                                        )?.totale_percentuale_materiali === 100,
                                    })}
                                  >
                                    {m !== 'rivendita' &&
                                    av.valori_materiali
                                      .find((valore) => valore.materiale === m)
                                      ?.totale_percentuale_materiali?.toFixed(2)
                                      ? av.valori_materiali
                                          .find(
                                            (valore) => valore.materiale === m
                                          )
                                          ?.totale_percentuale_materiali?.toFixed(
                                            2
                                          ) + '%'
                                      : ''}
                                    <br />
                                  </small>
                                  <hr />
                                  <div>
                                    {av.valori_materiali
                                      .find((valore) => valore.materiale === m)
                                      ?.ordini_fornitori.map((of, i) => (
                                        <div
                                          key={i}
                                          className="mt-1 pb-1 d-flex border-bottom pt-1"
                                        >
                                          <small className="mr-1">
                                            {of.ordine_fornitore_nome} <br />
                                            {of.stato}
                                            {of.data_arrivo
                                              ? ` (${moment(
                                                  of.data_arrivo
                                                ).format('DD/MM/YYYY')}) `
                                              : ' (Nessuna data) '}
                                            <br />
                                            <br />
                                            {of.valore_percentuale?.toFixed(2)}%
                                          </small>
                                          <i
                                            className="fas fa-pencil-alt text-warning ml-2 pointer"
                                            style={{ fontSize: '0.7rem' }}
                                            title="Modifica ordine fornitore"
                                            onClick={() => {
                                              setOpenModal({
                                                ...of,
                                                id: of.ordine_fornitore,
                                                data_arrivo: of.data_arrivo,
                                                stato: of.stato,
                                                valore_percentuale:
                                                  of.valore_percentuale,
                                              })
                                            }}
                                          />
                                        </div>
                                      ))}
                                  </div>
                                  
                                </td>
                              ))}

                              <td>{av.totale_valore_economico?.toFixed(2)}</td>
                              <td>{av.percentuale_avanzamento?.toFixed(2)}%</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  )}
                  {typeView === 'materiali' && (
                    <table className="table table-striped table-orders">
                      <thead
                        className="position-sticky"
                        style={{ top: 0, background: 'white', zIndex: 0 }}
                      >
                        <tr>
                          <th></th>
                          <th></th>
                          <th>
                            <DateRangeQsFilter
                              filters={filters}
                              onFiltersChange={onFiltersChange}
                              startField="from_data_consegna"
                              endField="to_data_consegna"
                              withPortal={true}
                              customArrowIcon={<div />}
                              small={false}
                              noBorder
                            />
                          </th>
                          <th className="text-nowrap">
                            <div style={{ width: 200 }}>
                              <Select
                                name="progetti"
                                isClearable={true}
                                placeholder={'Filtra per progetto'}
                                options={progetti?.map((progetto) => ({
                                  value: progetto,
                                  label: progetto,
                                }))}
                                classNamePrefix="multi-select"
                                hideSelectedOptions={false}
                                isMulti={true}
                                value={selectedProgetti}
                                className="basic-multi-select select-multi-options text-nowrap w-100"
                                onChange={(newValues) => {
                                  if (newValues) {
                                    const items = newValues.map(
                                      (item) => item.value
                                    )
                                    onFilterChange(items, 'progetti')
                                  } else {
                                    onFilterChange([], 'progetti')
                                  }
                                }}
                              />
                            </div>
                          </th>
                          <th></th>
                          <th>
                            <div className="badge badge-primary badge-xl">
                              {avanzamentiCommesseWithMateriali &&
                                sumBy(
                                  avanzamentiCommesseWithMateriali,
                                  'ordine_data.netto'
                                ).toLocaleString()}

                                
                            </div>
                          </th>

                          {intestazioneThMateriali.map((m, i) => (
                            <th key={i}>
                              <div className="badge badge-primary badge-xl">
                                {avanzamentiCommesseWithMateriali &&
                                  sumBy(
                                    avanzamentiCommesseWithMateriali,
                                    (av) =>
                                      sumBy(
                                        av.valori_materiali.filter(
                                          (valore) => valore.materiale === m
                                        ),
                                        'valore_economico_materiale_avanzamento'
                                      )
                                  )?.toLocaleString()}
                              </div>
                            </th>
                          ))}
                          <th></th>
                          <th>
                            <div className="badge badge-primary badge-xl">
                              {avanzamentiCommesseWithMateriali &&
                                sumBy(
                                  avanzamentiCommesseWithMateriali,
                                  'totale_valore_materiali_avanzamento'
                                )?.toLocaleString()}
                            </div>
                          </th>
                          <th>
                            <div className="badge badge-primary badge-xl">
                              {avanzamentiCommesseWithMateriali &&
                                (
                                  (sumBy(
                                    avanzamentiCommesseWithMateriali,
                                    'totale_valore_materiali_avanzamento'
                                  ) /
                                    sumBy(
                                      avanzamentiCommesseWithMateriali,
                                      'ordine_data.netto'
                                    )) *
                                  100
                                )?.toFixed(2)}
                              %
                            </div>
                          </th>
                        </tr>
                        <tr>
                          <th>Ordine</th>
                          <th>Codice sistema</th>
                          <th>Data approntamento</th>
                          <th>Progetto</th>
                          <th>Tipo cliente</th>
                          <th
                            className="position-relative pointer"
                            onClick={() => {
                              setOrderingMateriali({
                                field: 'ordine_data.netto',
                                direction:
                                  orderingMateriali.field ===
                                    'ordine_data.netto' &&
                                  orderingMateriali.direction === 'asc'
                                    ? 'desc'
                                    : 'asc',
                              })
                            }}
                          >
                            <span className="mr-3">Netto ordine</span>
                            <i
                              style={{
                                position: 'absolute',
                                top: 'calc(50% - 9px)',
                                right: 0,
                                color:
                                  ordering.field === 'ordine_data.netto' &&
                                  ordering.direction === 'asc'
                                    ? 'black'
                                    : '#ccc',
                              }}
                              className="fas fa-sort-up"
                            />
                            <i
                              style={{
                                position: 'absolute',
                                top: 'calc(50% - 7px)',
                                right: 0,
                                color:
                                  ordering.field === 'ordine_data.netto' &&
                                  ordering.direction === 'desc'
                                    ? 'black'
                                    : '#ccc',
                              }}
                              className="fas fa-sort-down"
                            />
                          </th>

                          {intestazioneThMateriali.map((m, i) => (
                            <th
                              key={i}
                              className="text-capitalize pointer position-relative"
                              onClick={() => {
                                setOrderingMateriali({
                                  field: `${m}_valore_materiale`,
                                  direction:
                                    orderingMateriali.field ===
                                      `${m}_valore_materiale` &&
                                    orderingMateriali.direction === 'asc'
                                      ? 'desc'
                                      : 'asc',
                                })
                              }}
                            >
                              <span className="mr-3">Valore {m}</span>
                              <i
                                style={{
                                  position: 'absolute',
                                  top: 'calc(50% - 9px)',
                                  right: 0,
                                  color:
                                    orderingMateriali.field ===
                                      `${m}_valore_materiale` &&
                                    orderingMateriali.direction === 'asc'
                                      ? 'black'
                                      : '#ccc',
                                }}
                                className="fas fa-sort-up"
                              />
                              <i
                                style={{
                                  position: 'absolute',
                                  top: 'calc(50% - 7px)',
                                  right: 0,
                                  color:
                                    orderingMateriali.field ===
                                      `${m}_valore_materiale` &&
                                    orderingMateriali.direction === 'desc'
                                      ? 'black'
                                      : '#ccc',
                                }}
                                className="fas fa-sort-down"
                              />
                            </th>
                          ))}
                          <th>Percentuali materiali</th>
                          <th>Totale valore economico</th>
                          <th
                            className="position-relative pointer"
                            onClick={() => {
                              setOrderingMateriali({
                                field: 'percentuale_avanzamento_av_materiali',
                                direction:
                                  orderingMateriali.field ===
                                    'percentuale_avanzamento_av_materiali' &&
                                  orderingMateriali.direction === 'asc'
                                    ? 'desc'
                                    : 'asc',
                              })
                            }}
                          >
                            {' '}
                            <span>Percentuale avanzamento</span>
                            <i
                              style={{
                                position: 'absolute',
                                top: 'calc(50% - 9px)',
                                right: 0,
                                color:
                                  ordering.field ===
                                    'percentuale_avanzamento_av_materiali' &&
                                  ordering.direction === 'asc'
                                    ? 'black'
                                    : '#ccc',
                              }}
                              className="fas fa-sort-up"
                            />
                            <i
                              style={{
                                position: 'absolute',
                                top: 'calc(50% - 7px)',
                                right: 0,
                                color:
                                  ordering.field ===
                                    'percentuale_avanzamento_av_materiali' &&
                                  ordering.direction === 'desc'
                                    ? 'black'
                                    : '#ccc',
                              }}
                              className="fas fa-sort-down"
                            />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {avanzamentiPerCommessaMaterialiOrdered &&
                          avanzamentiPerCommessaMaterialiOrdered
                            ?.filter(
                              (d) => d.totale_valore_materiali_avanzamento > 0
                            )
                            .map((av, i) => (
                              <tr key={i}>
                                <td>
                                  <Link to={`/ordini/${av.ordine_data.id}/`}>
                                    {av.ordine_data?.numero_commessa} -{' '}
                                    {av.ordine_data?.cliente?.nome}
                                  </Link>
                                  {av?.has_warnings_fornitori ? (
                                    <Link
                                      to={`/ordini/${av.ordine_data?.id}/avanzamento`}
                                    >
                                      <i
                                        className="fas fa-exclamation-triangle text-warning ml-2"
                                        title="Attenzione ordini fornitori non completi"
                                      ></i>
                                    </Link>
                                  ) : null}
                                </td>
                                <td>
                                  {av.ordine_data?.codice_sistema || 'N/D'}
                                </td>
                                <td>
                                  {moment(av.ordine_data?.data_consegna).format(
                                    'DD/MM/YYYY'
                                  )}
                                </td>
                                <td>{av.ordine_data?.progetto}</td>
                                <td>
                                  {av.ordine_data.agente_data?.tipo_agente ? (
                                    av.ordine_data.agente_data?.tipo_agente
                                  ) : (
                                    <span className="text-danger">
                                      Non definito
                                    </span>
                                  )}
                                </td>

                                <td>
                                  {av.ordine_data?.netto
                                    ? av.ordine_data?.netto?.toFixed(2)
                                    : 0}
                                </td>

                                {intestazioneThMateriali.map((m, i) => (
                                  <td key={i}>
                                    {av.valori_materiali.find(
                                      (valore) => valore.materiale === m
                                    )
                                      ?.valore_economico_materiale_avanzamento ? (
                                      sumBy(
                                        av.valori_materiali.filter(
                                          (valore) => valore.materiale === m
                                        ),
                                        'valore_economico_materiale_avanzamento'
                                      ).toFixed(2)
                                    ) : (
                                      <span className="text-danger">
                                        {av.valori_materiali_fuori_range
                                          .find(
                                            (valore) => valore.materiale === m
                                          )
                                          ?.valore_economico_materiale_avanzamento?.toFixed(
                                            2
                                          )}
                                      </span>
                                    )}
                                    <br />
                                    {av.valori_materiali_fuori_range.find(
                                      (valore) => valore.materiale === m
                                    )
                                      ?.valore_economico_materiale_avanzamento && (
                                      <small className="text-danger">
                                        (+
                                        {av.valori_materiali_fuori_range
                                          .find(
                                            (valore) => valore.materiale === m
                                          )
                                          ?.valore_economico_materiale_avanzamento?.toFixed(
                                            2
                                          )}
                                        )
                                      </small>
                                    )}
                                    <br />
                                    <small>
                                      {av.valori_materiali.find(
                                        (valore) => valore.materiale === m
                                      )
                                        ?.valore_economico_materiale_avanzamento &&
                                        (
                                          (av.valori_materiali.find(
                                            (valore) => valore.materiale === m
                                          )
                                            ?.valore_economico_materiale_avanzamento /
                                            av.ordine_data?.netto) *
                                          100
                                        ).toFixed(2) + '%'}
                                      <br />
                                    </small>
                                    <hr />
                                    <div>
                                      {av.valori_materiali
                                        .find(
                                          (valore) => valore.materiale === m
                                        )
                                        ?.ordini_fornitori.map((of, i) => (
                                          <div
                                            key={i}
                                            className={classNames(
                                              'mt-1 pb-1 d-flex border-bottom pt-1',
                                              {
                                                'text-danger':
                                                  moment(
                                                    of.data_arrivo
                                                  ).isBefore(
                                                    filters.from_date
                                                  ) ||
                                                  moment(
                                                    of.data_arrivo
                                                  ).isAfter(filters.to_date),
                                              }
                                            )}
                                          >
                                            <small className="mr-1">
                                              {of.ordine_fornitore_nome} <br />
                                              {of.stato}
                                              {of.data_arrivo
                                                ? ` (${moment(
                                                    of.data_arrivo
                                                  ).format('DD/MM/YYYY')}) `
                                                : ' (Nessuna data) '}
                                              <br />
                                              <br />
                                              {of.valore_percentuale?.toFixed(
                                                2
                                              )}
                                              %
                                            </small>
                                            <i
                                              className="fas fa-pencil-alt text-warning ml-2 pointer"
                                              style={{ fontSize: '0.7rem' }}
                                              title="Modifica ordine fornitore"
                                              onClick={() => {
                                                setOpenModal({
                                                  ...of,
                                                  id: of.ordine_fornitore,
                                                  data_arrivo: of.data_arrivo,
                                                  stato: of.stato,
                                                  valore_percentuale:
                                                    of.valore_percentuale,
                                                })
                                              }}
                                            />
                                          </div>
                                        ))}
                                    </div>
                                    
                                    <div>
                                      {/* show ordini fornitori of materiali fuori range */}
                                      {!av.valori_materiali.find(
                                        (val) => val.materiale === m
                                      ) &&
                                        av.valori_materiali_fuori_range
                                          .find(
                                            (valore) => valore.materiale === m
                                          )
                                          ?.ordini_fornitori.map((of, i) => (
                                            <div
                                              key={i}
                                              className="mt-1 pb-1 d-flex border-bottom pt-1 text-danger"
                                            >
                                              <small className="mr-1">
                                                {of.ordine_fornitore_nome}{' '}
                                                <br />
                                                {of.stato}
                                                {of.data_arrivo
                                                  ? ` (${moment(
                                                      of.data_arrivo
                                                    ).format('DD/MM/YYYY')}) `
                                                  : ' (Nessuna data) '}
                                                <br />
                                                <br />
                                                {of.valore_percentuale?.toFixed(
                                                  2
                                                )}
                                                %
                                              </small>
                                              <i
                                                className="fas fa-pencil-alt text-warning ml-2 pointer"
                                                style={{ fontSize: '0.7rem' }}
                                                title="Modifica ordine fornitore"
                                                onClick={() => {
                                                  setOpenModal({
                                                    ...of,
                                                    id: of.ordine_fornitore,
                                                    data_arrivo: of.data_arrivo,
                                                    stato: of.stato,
                                                    valore_percentuale:
                                                      of.valore_percentuale,
                                                  })
                                                }}
                                              />
                                            </div>
                                          ))}
                                    </div>

                                    {/* if there are warnings for this order, show them are like ordini fornitori */}
                                    {av?.warnings
                                      ?.filter((w) => w.tipologia === m)
                                      .map((of, i) => (
                                        <div
                                          style={{ color: 'darkorange' }}
                                          key={i}
                                          className="mt-1 pb-1 d-flex border-bottom pt-1"
                                        >
                                          <small className="mr-1">
                                            {of.ordine_fornitore_nome} <br />
                                            {of.stato}
                                            {of.data_arrivo
                                              ? ` (${moment(
                                                  of.data_arrivo
                                                ).format('DD/MM/YYYY')}) `
                                              : ' (Nessuna data) '}
                                            <br />
                                            <br />
                                            {of.valore_percentuale?.toFixed(2)}%
                                          </small>
                                          <i
                                            className="fas fa-pencil-alt text-warning ml-2 pointer"
                                            style={{ fontSize: '0.7rem' }}
                                            title="Modifica ordine fornitore"
                                            onClick={() => {
                                              setOpenModal({
                                                ...of,
                                                id: of.ordine_fornitore,
                                                data_arrivo: of.data_arrivo,
                                                stato: of.stato,
                                                valore_percentuale:
                                                  of.valore_percentuale,
                                              })
                                            }}
                                          />
                                        </div>
                                      ))}
                                  </td>
                                ))}
                                <td className="text-nowrap">
                                  <small>Perc totale</small> <br />
                                  {/* sum valori_materiali and valori_materiali_fuori_range */}
                                  <span
                                    className={classNames({
                                      'text-success':
                                        // if the sum is 100
                                        (
                                          ((sumBy(
                                            av.valori_materiali,
                                            'valore_economico_materiale_avanzamento'
                                          ) +
                                            sumBy(
                                              av.valori_materiali_fuori_range,
                                              'valore_economico_materiale_avanzamento'
                                            )) /
                                            av.ordine_data?.netto) *
                                          100
                                        ).toFixed(2) === '100.00',
                                      'text-danger':
                                        (
                                          ((sumBy(
                                            av.valori_materiali,
                                            'valore_economico_materiale_avanzamento'
                                          ) +
                                            sumBy(
                                              av.valori_materiali_fuori_range,
                                              'valore_economico_materiale_avanzamento'
                                            )) /
                                            av.ordine_data?.netto) *
                                          100
                                        ).toFixed(2) !== '100.00',
                                    })}
                                  >
                                    {(
                                      ((sumBy(
                                        av.valori_materiali,
                                        'valore_economico_materiale_avanzamento'
                                      ) +
                                        sumBy(
                                          av.valori_materiali_fuori_range,
                                          'valore_economico_materiale_avanzamento'
                                        )) /
                                        av.ordine_data?.netto) *
                                      100
                                    ).toFixed(2)}{' '}
                                    %
                                  </span>
                                  {av?.has_warnings_fornitori ? (
                                    <Link
                                      to={`/ordini/${av.ordine_data?.id}/avanzamento`}
                                    >
                                      <i
                                        className="fas fa-exclamation-triangle text-warning ml-2"
                                        title="Attenzione ordini fornitori non completi"
                                      ></i>
                                    </Link>
                                  ) : null}
                                  <br />
                                  <br />
                                  <small className="mt-1">Perc. mat.</small>
                                  <br />
                                  {(
                                    (sumBy(
                                      av.valori_materiali,
                                      'valore_economico_materiale_avanzamento'
                                    ) /
                                      av.ordine_data?.netto) *
                                    100
                                  ).toFixed(2)}{' '}
                                  %
                                  <br />
                                  <br />
                                  <small className="mt-1">
                                    Perc. fuori range
                                  </small>
                                  <br />
                                  {(
                                    (sumBy(
                                      av.valori_materiali_fuori_range,
                                      'valore_economico_materiale_avanzamento'
                                    ) /
                                      av.ordine_data?.netto) *
                                    100
                                  ).toFixed(2)}{' '}
                                  %
                                </td>
                                <td>
                                  {av.totale_valore_materiali_avanzamento?.toFixed(
                                    2
                                  )}
                                </td>
                                <td
                                  className={classNames({
                                    'text-success':
                                      av.percentuale_avanzamento_av_materiali?.toFixed(
                                        2
                                      ) === '100.00',
                                  })}
                                >
                                  {av.percentuale_avanzamento_av_materiali?.toFixed(
                                    2
                                  )}
                                  %
                                </td>
                              </tr>
                            ))}
                      </tbody>
                    </table>
                  )}
                  {typeView === 'per-giorno' && (
                    <table className="table table-striped table-orders">
                      <thead
                        className="position-sticky"
                        style={{ top: 0, background: 'white', zIndex: 0 }}
                      >
                        <tr>
                          <th></th>
                          <th>
                            <div className="badge badge-primary badge-xl">
                              {avanzamentoPerGiorno
                                ? sumBy(
                                    avanzamentoPerGiorno
                                      .map(
                                        (av) => av.valore_economico_materiale
                                      )
                                      .filter((v) => v),
                                    (v) => v
                                  ).toFixed(2)
                                : 0}
                            </div>
                          </th>
                          <th>
                            <div className="badge badge-primary badge-xl">
                              {avanzamentoPerGiorno
                                ? sumBy(
                                    avanzamentoPerGiorno
                                      .map((av) => av.totale_valore_economico)
                                      .filter((v) => v),
                                    (v) => v
                                  ).toFixed(2)
                                : 0}
                            </div>
                          </th>
                        </tr>
                        <tr>
                          <th>Data</th>
                          <th>Valore econ. materiali</th>
                          <th>Totale valore economico</th>
                        </tr>
                      </thead>
                      <tbody>
                        {avanzamentoPerGiorno &&
                          avanzamentoPerGiorno?.map((av, i) => (
                            <tr key={i}>
                              <td>{moment(av.data).format('DD/MM/YYYY')}</td>

                              <td>
                                {av.valore_economico_materiale?.toFixed(2)}
                              </td>

                              <td>{av.totale_valore_economico?.toFixed(2)}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            )}
          </div>
          {avanzamenti && typeView === 'avanzamento-ordini' && (
            <Paginator
              numPages={pagination.numPages}
              currentPage={page}
              goToPage={goToPage}
            />
          )}
        </div>
      </div>

      <Modal
        isOpen={openModal}
        toggle={() => setOpenModal(null)}
        size="md"
        centered
      >
        <ModalHeader toggle={() => setOpenModal(null)}>
          Modifica ordine fornitore {openModal?.fornitore_data?.nome}
        </ModalHeader>
        <ModalBody>
          <Formik
            initialValues={{
              data_arrivo: openModal?.data_arrivo,
              stato: openModal?.stato,
              valore_percentuale: openModal?.valore_percentuale,
            }}
            onSubmit={(values, actions) => {
              updatePercentuale
                .onSuccess(() => {
                  actions.setSubmitting(false)
                  setOpenModal(null)
                  runAvanzamentiCommesse({
                    ...filtersToUse,
                  })
                })
                .onFailure((error) => {
                  actions.setSubmitting(false)
                  actions.setErrors(transformErrorForForm(error))
                })
                .run(openModal.id, values)
              // updateStatoAndData
              //   .onSuccess(() => {
              //     actions.setSubmitting(false)
              //     setOpenModal(null)
              //   })
              //   .onFailure((error) => {
              //     actions.setSubmitting(false)
              //     actions.setErrors(transformErrorForForm(error))
              //   })
              //   .run(openModal.id, values)
            }}
          >
            {({ handleSubmit, isSubmitting }) => (
              <form onSubmit={handleSubmit}>
                <div className="form-group mt-3">
                  <Field
                    label="Data arrivo"
                    type="text"
                    name="data_arrivo"
                    component={DateField}
                    className="form-control"
                  />
                  <div className="form-group mt-3">
                    <Field
                      label="Valore percentuale"
                      name="valore_percentuale"
                      component={InputField}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group mt-3">
                    <Field
                      label="Stato"
                      type="select"
                      name="stato"
                      component={InputField}
                      className="form-control"
                    >
                      <option value=""></option>
                      {stati.map((stato) => (
                        <option key={stato.nome} value={stato.nome}>
                          {stato.nome}
                        </option>
                      ))}
                    </Field>
                  </div>
                </div>

                <div className="form-group mt-3 d-flex justify-content-end">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isSubmitting}
                  >
                    Salva
                  </button>
                </div>
              </form>
            )}
          </Formik>
        </ModalBody>
      </Modal>
      {modalRimanenze && (
        <ModalRimanenze
          runAvanzamentiCommesse={runAvanzamentiCommesse}
          ordine={modalRimanenze}
          isOpen={modalRimanenze !== null}
          toggle={() => setModalRimanenze(null)}
          filtersToUse={filtersToUse}
        />
      )}
    </div>
  )
}
